interface GroupedDropdownSelection {
  groupLabel: string
  optionLabel: string
  group: { id: number | string; name: string }
  option: { id: number | string; name: string }
}

export const composeGroupedDropdownReply = ({
  groupLabel,
  optionLabel,
  group,
  option,
}: GroupedDropdownSelection): string =>
  `${groupLabel}: ${group.name} (id ${group.id}), ${optionLabel}: ${option.name} (id ${option.id})`
